export const PlanCardSkeleton = () => (
  <div className="min-w-0 w-full animate-pulse rounded-[24px] border border-line-subdued bg-surface px-5 pb-5 pt-6 lg:min-w-64">
    <div className="flex h-full flex-col">
      <div className="pb-3">
        <div className="h-5 w-1/3 rounded bg-skeleton" />
      </div>

      <div className="space-y-2 pb-5">
        <div className="h-4 w-1/4 rounded bg-skeleton" />
        <div className="h-8 w-2/3 rounded bg-skeleton" />
        <div className="h-3 w-1/2 rounded bg-skeleton" />
      </div>

      <div className="flex flex-grow flex-col gap-2.5">
        {[...Array(6)].map((_, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className="flex items-start gap-2"
          >
            <div className="mt-0.5 size-4 shrink-0 rounded-full bg-skeleton" />
            <div className="mt-0.5 h-3 w-full rounded bg-skeleton" />
          </div>
        ))}
      </div>

      <div className="pb-5 pt-6">
        <div className="mb-2 h-3 w-1/4 rounded bg-skeleton" />
        <div className="flex gap-1.5">
          {[...Array(3)].map((_, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className="size-[18px] rounded-sm bg-skeleton"
            />
          ))}
        </div>
      </div>

      <div className="mt-auto flex flex-col gap-2 pt-6">
        <div className="h-11 rounded-full bg-skeleton" />
        <div className="mx-auto h-3 w-20 rounded bg-skeleton" />
      </div>
    </div>
  </div>
)
